import React from "react";
import LeafNetLogo from "./LeafNetLogo";
import CocoLogo from "../PlantAssistant/CocoLogo";
import { UI_CLASSIC, setUiMode } from "./uiMode";
import "./auth.css";

/**
 * The new-UI frame for the signed-out pages (Login, ForgotForm): a brand panel on the
 * left and the page's form card on the right. The pages keep their own state and
 * handlers and only swap their markup for this when the new UI is on.
 */
export default function AuthShell({ children }) {
  return (
    <div className="lnauth">
      <section className="lnauth-brand" aria-label="LeafNet">
        <div className="lnauth-logo">
          <LeafNetLogo size={44} title="LeafNet" />
          <span aria-hidden="true">LEAFNET</span>
        </div>

        <div className="lnauth-pitch">
          <span className="lnauth-sticker">Production monitoring</span>
          <p className="lnauth-headline">
            Every machine, every shift, <em>at a glance.</em>
          </p>
          <p className="lnauth-lede">
            Live status, OEE, downtime and reports for your whole plant, with Coco on hand
            to answer questions about any of it.
          </p>
        </div>

        <div className="lnauth-stickers" aria-hidden="true">
          <span className="lnauth-chip lnauth-chip--lime">Live machine status</span>
          <span className="lnauth-chip lnauth-chip--butter">OEE &amp; downtime</span>
          <span className="lnauth-chip lnauth-chip--white">Reports &amp; exports</span>
          <div className="lnauth-coco">
            <CocoLogo className="pa-logo-md" />
            <span>
              <b>Coco:</b> ask me about any machine, shift or report.
            </span>
          </div>
        </div>
      </section>

      <main className="lnauth-main">
        <div className="lnauth-card">{children}</div>
        <p className="lnauth-credit">
          Powered by{" "}
          <a href="https://drititech.com" target="_blank" rel="noopener noreferrer">
            DRITI TECHNOLOGIES LLP
          </a>
        </p>
        <button type="button" className="lnauth-switch" onClick={() => setUiMode(UI_CLASSIC)}>
          Use the classic look
        </button>
      </main>
    </div>
  );
}

/** A labelled input row with its validation message, for the forms inside AuthShell. */
export function AuthField({ id, label, error, aside, children }) {
  return (
    <div className="lnauth-field">
      <div className="lnauth-label-row">
        <label htmlFor={id}>{label}</label>
        {aside}
      </div>
      {children}
      {error ? (
        <div className="lnauth-error" id={`${id}-error`} role="alert">
          {error}
        </div>
      ) : null}
    </div>
  );
}
